import TradeInModal from './TradeInModal.vue'

export default TradeInModal
